module.exports = "https://coursera_assets.s3.amazonaws.com/images/c325e23d0982e41cb2879334e04d7cc0.png";